import type { SessionLifecycleGateway } from '@core/ports/SessionLifecycleGateway';

export class LogOutSessionUseCase {
  public constructor(private readonly sessionLifecycleGateway: SessionLifecycleGateway) {}

  public async execute(): Promise<void> {
    await this.sessionLifecycleGateway.logOut();
  }
}
